"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _reactWaypoint = require("react-waypoint");

var _immutable = require("immutable");

var _reactPolyglot = require("react-polyglot");

var _collections = require("../../../reducers/collections");

var _publishModes = require("../../../constants/publishModes");

var _EntryCard = _interopRequireDefault(require("./EntryCard"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const CardsGrid = (0, _styledBase.default)("ul", {
  target: "e1hbvtjf0",
  label: "CardsGrid"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

class EntryListing extends _react.default.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "hasMore", () => {
      var _this$props$cursor, _this$props$cursor$ac;

      const hasMore = (_this$props$cursor = this.props.cursor) === null || _this$props$cursor === void 0 ? void 0 : (_this$props$cursor$ac = _this$props$cursor.actions) === null || _this$props$cursor$ac === void 0 ? void 0 : _this$props$cursor$ac.has('append_next');
      return hasMore;
    });

    _defineProperty(this, "handleLoadMore", () => {
      if (this.hasMore()) {
        this.props.handleCursorActions('append_next');
      }
    });

    _defineProperty(this, "handleChangeStatus", (newStatus, dragProps) => {
      const slug = dragProps.slug;
      const collection = dragProps.collection;
      const oldStatus = dragProps.status;
      this.props.handleChangeStatus(collection, slug, oldStatus, newStatus);
    });

    _defineProperty(this, "requestDownload", (collection, slug, ownStatus) => {
      window.location.href = `${this.props.config.stop_url}/repo/${this.props.config.repo_id}/branch/${this.props.config.backend.branch}/file/${slug}`;
    });

    _defineProperty(this, "requestDelete", (collection, slug, ownStatus) => {
      if (window.confirm(this.props.t(ownStatus ? 'editor.editor.onDeleteUnpublishedChanges' : 'editor.editor.onDeletePublishedEntry'))) {
        this.props.handleDelete(collection, slug, ownStatus).then(() => window.location.reload());
      }
    });

    _defineProperty(this, "requestPublish", (collection, slug, ownStatus) => {
      if (ownStatus !== _publishModes.status.last()) {
        window.alert(this.props.t('editor.editor.onPublishingNotReady'));
        return;
      } else if (!window.confirm(this.props.t('editor.editor.onPublishing'))) {
        return;
      }

      this.props.handlePublish(collection, slug).then(() => window.location.reload());
    });

    _defineProperty(this, "inferFields", collection => {
      const titleField = (0, _collections.selectInferedField)(collection, 'title');
      const descriptionField = (0, _collections.selectInferedField)(collection, 'description');
      const imageField = (0, _collections.selectInferedField)(collection, 'image');
      const fields = (0, _collections.selectFields)(collection);
      const inferedFields = [titleField, descriptionField, imageField];
      const remainingFields = fields && fields.filter(f => inferedFields.indexOf(f.get('name')) === -1);
      return {
        titleField,
        descriptionField,
        imageField,
        remainingFields
      };
    });

    _defineProperty(this, "renderCardsForSingleCollection", () => {
      const {
        collections,
        entries,
        viewStyle
      } = this.props;
      const inferedFields = this.inferFields(collections);
      const entryCardProps = {
        collection: collections,
        inferedFields,
        viewStyle,
        handleChangeStatus: this.handleChangeStatus
      };
      return entries.map((entry, idx) => {
        const collectionName = entry.get('collection');
        const ownStatus = entry.get('status');
        const slug = entry.get('slug');
        const data = entry.get('data');
        const previewLink = data.interactiveIds ? data.interactiveIds[0] : slug;
        entryCardProps.slug = previewLink;
        entryCardProps.handlePublish = this.requestPublish.bind(this, collectionName, slug, ownStatus);
        entryCardProps.handleDownload = this.requestDownload.bind(this, collectionName, slug, ownStatus);
        entryCardProps.handleDelete = this.requestDelete.bind(this, collectionName, slug, ownStatus);
        entryCardProps.status = entry.get('status') ? entry.get('status') : 'published';
        entryCardProps.lastAuthored = entry.get('author');
        entryCardProps.lastUpdated = entry.get('updatedOn');
        entryCardProps.lastPublished = entry.get('publishedOn');
        let cardColor = '#caef6f';

        switch (entryCardProps.status) {
          case 'draft':
            cardColor = '#f6d8ff';
            break;

          case 'pending_publish':
            cardColor = '#ffee9c';
            break;
        }

        return (0, _core.jsx)(_EntryCard.default, _extends({
          style: {
            backgroundColor: cardColor
          }
        }, entryCardProps, {
          entry: entry,
          key: idx
        }));
      });
    });

    _defineProperty(this, "renderCardsForMultipleCollections", () => {
      const {
        collections,
        entries
      } = this.props;
      const isSingleCollectionInList = collections.size === 1;
      return entries.map((entry, idx) => {
        const collectionName = entry.get('collection');
        const collection = collections.find(coll => coll.get('name') === collectionName);
        const collectionLabel = !isSingleCollectionInList && collection.get('label');
        const inferedFields = this.inferFields(collection);
        const entryStatus = 'published';
        const lastAuthored = entry.get('author');
        const lastUpdated = entry.get('updatedOn');
        const lastPublished = entry.get('publishedOn');
        const entryCardProps = {
          collection,
          entry,
          inferedFields,
          collectionLabel,
          entryStatus,
          lastAuthored,
          lastUpdated,
          lastPublished
        };
        return (0, _core.jsx)(_EntryCard.default, _extends({}, entryCardProps, {
          key: idx
        }));
      });
    });
  }

  render() {
    const {
      collections,
      page
    } = this.props;
    return (0, _core.jsx)("div", null, (0, _core.jsx)(CardsGrid, null, _immutable.Map.isMap(collections) ? this.renderCardsForSingleCollection() : this.renderCardsForMultipleCollections(), this.hasMore() && (0, _core.jsx)(_reactWaypoint.Waypoint, {
      key: page,
      onEnter: this.handleLoadMore
    })));
  }

}

exports.default = EntryListing;

_defineProperty(EntryListing, "propTypes", {
  collections: _reactImmutableProptypes.default.iterable.isRequired,
  entries: _reactImmutableProptypes.default.list,
  unpublishedEntries: _reactImmutableProptypes.default.list,
  viewStyle: _propTypes.default.string,
  cursor: _propTypes.default.any.isRequired,
  handleCursorActions: _propTypes.default.func.isRequired,
  handleChangeStatus: _propTypes.default.func.isRequired,
  handlePublish: _propTypes.default.func.isRequired,
  handleDelete: _propTypes.default.func.isRequired,
  page: _propTypes.default.number,
  t: _propTypes.default.func.isRequired
});